import { render } from "./SelecionarCamposRelatorioVendas.vue?vue&type=template&id=36e376d4&scoped=true&ts=true"
import script from "./SelecionarCamposRelatorioVendas.vue?vue&type=script&lang=ts"
export * from "./SelecionarCamposRelatorioVendas.vue?vue&type=script&lang=ts"

import "./SelecionarCamposRelatorioVendas.vue?vue&type=style&index=0&id=36e376d4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e376d4"]])

export default __exports__